import React from "react";

export default function Store() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.4721 4.20709L3.81557 2.56913L3.5935 1.11129C3.55747 0.871311 3.37747 0.679255 3.14348 0.619259L0.743382 0.0192989C0.425424 -0.0646681 0.0954235 0.133398 0.0173173 0.457338C-0.0606311 0.775262 0.131428 1.10523 0.455404 1.18332L2.46549 1.68726L2.69344 3.19922L3.85142 10.8907L4.0554 12.2586C4.19349 13.1525 4.94351 13.8004 5.83755 13.8004H16.2002C16.5302 13.8004 16.8002 13.5304 16.8002 13.2004C16.8002 12.8704 16.5302 12.6005 16.2002 12.6005H5.83755C5.53754 12.6005 5.28546 12.3784 5.24356 12.0784L5.14163 11.4005H15.5999C16.926 11.4005 18 10.3266 18 9.0007V4.80098C18 4.49497 17.772 4.24309 17.472 4.20705L17.4721 4.20709Z"
                fill="#4F6E90"/>
            <path
                d="M6.59964 14.4004C5.60959 14.4004 4.79956 15.2103 4.79956 16.2003C4.79956 17.1902 5.60959 18.0002 6.59964 18.0002C7.58968 18.0002 8.39971 17.1902 8.39971 16.2003C8.39971 15.2103 7.58968 14.4004 6.59964 14.4004Z"
                fill="#354F6C"/>
            <path
                d="M15 14.4004C14.01 14.4004 13.2 15.2103 13.2 16.2003C13.2 17.1902 14.01 18.0002 15 18.0002C15.9901 18.0002 16.8001 17.1902 16.8001 16.2003C16.8001 15.2103 15.9901 14.4004 15 14.4004Z"
                fill="#354F6C"/>
        </svg>
    )
}
